module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/LeahRiminiScientology.893045d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/LeahRiminiScientology.jpg
// module id = mAEj
// module chunks = 0